<template>
    <dashlet-card :chipText="tClientCount"
                  :page-tooltip="t_page_tooltip_clientstatus"
                  :page-href="privilegeManage ? '/system/client-status' : undefined"
                  :title="t_title">
        <div v-if="clients?.length > 0"
             class="table-container">
            <table class="table">
                <thead>
                <tr>
                    <th class="sorting_disabled">
                        {{ t_location_name }}
                    </th>
                    <th class="sorting_disabled">
                        {{ t_connection }}
                    </th>
                    <th class="sorting_disabled">
                        {{ t_status }}
                    </th>
                    <th class="sorting_disabled">
                        <span-with-tooltip :tooltip-text="t_last_24">
                            {{ t_fatal_errors }}
                            <i class="fa-light fa-circle-question cursor-pointer" />
                        </span-with-tooltip>
                    </th>
                    <th class="sorting_disabled">
                        <span-with-tooltip :tooltip-text="t_last_24">
                            {{ t_errors }}
                            <i class="fa-light fa-circle-question cursor-pointer" />
                        </span-with-tooltip>
                    </th>
                    <th class="sorting_disabled">
                        <span-with-tooltip :tooltip-text="t_last_24">
                            {{ t_warnings }}
                            <i class="fa-light fa-circle-question cursor-pointer" />
                        </span-with-tooltip>
                    </th>
                    <th class="sorting_disabled">
                        {{ t_clients }}
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="entry in clients" class="client-list-row">
                    <td>
                        <a :href="`/system/client-status/${entry['location_id']}`">
                            {{ entry['name'] ? entry['name'] : '???' }}
                        </a>
                    </td>
                    <td>
                        <i v-if="entry['inactive'] === entry['players']"
                           class="fa-solid fa-circle traffic-grey"
                           title="" />
                        <i v-else-if="entry['connect_failures']['errors'] > 0"
                           class="fa-solid fa-circle traffic-red"
                           title="" />
                        <i v-else-if="entry['connect_failures']['warnings'] > 0"
                           class="fa-solid fa-circle traffic-orange"
                           title="" />
                        <i v-else
                           class="fa-solid fa-circle traffic-green"
                           title="" />
                    </td>
                    <td>
                        <i v-if="entry['inactive'] === entry['players'] || entry['connect_failures']['errors'] > 0"
                           class="fa-solid fa-circle traffic-grey"
                           title="" />
                        <i v-else-if="entry['fatals'] > 0"
                           class="fa-solid fa-circle traffic-red"
                           title="" />
                        <i v-else-if="entry['errors'] > 0"
                           class="fa-solid fa-circle traffic-orange"
                           title="" />
                        <i v-else-if="entry['warnings'] > 0"
                           class="fa-solid fa-circle traffic-yellow"
                           title="" />
                        <i v-else
                           class="fa-solid fa-circle traffic-green"
                           title="" />
                    </td>
                    <td>
                        {{ entry['fatals'].toLocaleString() }}
                    </td>
                    <td>
                        {{ entry['errors'].toLocaleString() }}
                    </td>
                    <td>
                        {{ entry['warnings'].toLocaleString() }}
                    </td>
                    <td>
                        {{ entry['players'] }}
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-else
             class="dashlet-message-container">
            {{ noClientsMessage }}
        </div>
    </dashlet-card>
</template>

<script>
import DashletCard from './dashlet-card.vue'
import SpanWithTooltip from '../../content/common/spanWithTooltip.vue'

export default {
    components: { SpanWithTooltip, DashletCard },
    props: {
        clients: {
            type: Array,
            default: () => []
        },
        /** @type {'1' | undefined} */
        privilegeManage: String,
        tClientCount: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            t_title: Lang.langGet('Client Overview'),
            t_page_tooltip_clientstatus: Lang.langGet('Client Status'),
            t_location_name: Lang.langGet('Location Name'),
            t_connection: Lang.langGet('Connection'),
            t_status: Lang.langGet('Status'),
            t_fatal_errors: Lang.langChoice('Fatal Error|Fatal Errors', 2),
            t_errors: Lang.langChoice('Error|Errors', 2),
            t_warnings: Lang.langChoice('Warning|Warnings', 2),
            t_clients: Lang.langChoice('Client|Clients', 2),
            t_last_24: Lang.langGet('for the last 24h')
        }
    },
    computed: {
        noClientsMessage() {
            return `0 ${this.t_clients}`
        }
    }
}
</script>

<style scoped>
    .client-list-row:hover {
        background-color: var(--project-table-hover-color) !important;
    }
</style>
